<template>
  <div>
    <el-card>
      <div style="display: flex">
        <div style="width: 50%">
          <el-row>
            <el-col v-if="isShow">
              <el-button :disabled="editFlag" size="small" type="warning" @click="stprEdit">编辑</el-button>
            </el-col>
            <el-col v-else>
              <el-button size="small" type="primary" @click="submit()">保存</el-button>
              <el-button size="small" @click="closeEdit">取消</el-button>
            </el-col>
          </el-row>
          <el-form ref="laseRef" :disabled="isShow" :model="prop" :rules="laseRules" label-width="120px" size="small">
            <el-row>
              <el-col :md="12">
                <el-form-item label="手裁用量：" prop="rfid_handcut_phr">
                  <el-input :value="prop.rfid_handcut_phr" maxlength="9" show-word-limit @input="rfid_handcut_phrChange">
                    <template slot="append">片</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--<el-row>-->
            <!--  <el-col :md="12">-->
            <!--    <el-form-item label="试样片数：" prop="sample_phr">-->
            <!--      <el-input :value="prop.sample_phr" maxlength="9" show-word-limit @input="sample_phrChange">-->
            <!--        <template slot="append">片</template>-->
            <!--      </el-input>-->
            <!--    </el-form-item>-->
            <!--  </el-col>-->
            <!--</el-row>-->
            <!--<el-row>-->
            <!--  <el-col :md="12">-->
            <!--    <el-form-item label="试样个数：" prop="sample_num">-->
            <!--      <el-input :value="prop.sample_num" maxlength="9" show-word-limit @input="sample_numChange">-->
            <!--        <template slot="append">个</template>-->
            <!--      </el-input>-->
            <!--    </el-form-item>-->
            <!--  </el-col>-->
            <!--</el-row>-->
            <el-row>
              <el-col :md="12">
                <el-form-item label="填卡人：" prop="card_user_id">
                  <el-select v-model="prop.card_user_id" filterable placeholder="请选择">
                    <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form :disabled="isShow" label="right" label-width="100px">
            <el-row>
              <el-form-item label="工序制作人：" size="small">
                <el-select
                  v-model="prop.stff_id"
                  :disabled="!['徐礼明', '盖新', 'Admin'].includes($cookies.get('userInfo').stff_name)"
                  filterable
                  placeholder="请选择"
                  @change="
                    val => {
                      const find = processList.find(item => item.value === val).o;
                      prop.user_id = find.user_id;
                      prop.stff_name = find.stff_name;
                    }
                  "
                >
                  <el-option v-for="item in processList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="岗位：" size="small">
                <el-input :value="prop.rfid_handcut_post" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="难度系数：" size="small">
                <el-input :value="prop.price" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item>
                <SubTable2 ref="subTable" :isShow="isShow" :stffList="processList" />
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { post } from '@api/request';
import { rfidAPI } from '@api/modules/rfid';
import helper from '@assets/js/helper';
import SubTable2 from '@/views/DevelopManagement/SmplManage/TabChild/Componet/TabPanel/subTable/subTable2';

export default {
  components: {
    SubTable2
  },
  data() {
    return {
      isShow: true,
      laseRules: {
        rfid_handcut_phr: [
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' },
          { required: true, message: '请填写手裁用量', trigger: true }
        ]
      }
    };
  },
  watch: {
    'prop.rfidProcessItems'(newValue, oldValue) {
      this.$refs.subTable.tableData = newValue;
    }
  },
  props: {
    prop: Object,
    rfid_perm_status: Number,
    rfid_Info: Object,
    editFlag: Boolean,
    mainIsShow: Boolean,
    originalhandCut: Object,
    stffList: Array,
    processList: Array
  },
  methods: {
    stprEdit() {
      this.$emit('num');
      this.isShow = false;
    },
    submit() {
      this.$refs['laseRef'].validate(valid => {
        if (valid) {
          this.$confirm('此操作将保存修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(res => {
              let editBody = {};
              editBody = JSON.parse(JSON.stringify(this.prop));
              editBody.rfid_handcut_id = this.prop.rfid_handcut_id;
              editBody.rfidProcessItems = this.$refs.subTable.tableData.filter(x =>
                x.rfid_handcut_id ? true : !x.rfid_handcut_id && !x.destroy_flag
              );
              if (!editBody.rfid_id) {
                editBody.rfid_id = this.rfid_Info.rfid_id;
                editBody.user_id = this.rfid_Info.user_id;
                editBody.stff_name = this.rfid_Info.stff_name;
                editBody.stff_id = this.rfid_Info.stff_id;
              }
              post(rfidAPI.edit_handCut, editBody)
                .then(res => {
                  if (res.data.code === 0) {
                    this.$message.success(res.data.msg);
                    this.$emit('copyHand', this.prop);
                  } else {
                    this.$message.error(res.data.msg);
                  }

                  this.$emit('del');
                })
                .catch(res => {
                  this.$message.error(res.data.msg);
                });

              this.isShow = true;
            })
            .catch(res => {});
        }
      });
    },
    closeEdit() {
      this.$confirm('此操作将取消修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          this.isShow = true;
          this.$message.info('已取消修改');
          this.$emit('del');
          this.prop.rfid_handcut_phr = this.originalhandCut.rfid_handcut_phr;
          this.prop.sample_phr = this.originalhandCut.sample_phr;
          this.prop.sample_num = this.originalhandCut.sample_num;
        })
        .catch(res => {});
    },
    rfid_handcut_phrChange(val) {
      val = this.keepNum99(val);
      this.$emit('rfid_handcut_phrChange', val);
    },
    sample_phrChange(val) {
      val = this.helper.keepTNum(val);
      this.$emit('sample_phrChange', val);
    },
    sample_numChange(val) {
      val = this.helper.keepTNum(val);
      this.$emit('sample_numChange', val);
    },
    keepNum99(val) {
      let keepTNum = Number(helper.keepTNum(val));
      if (keepTNum > 99) {
        this.$message.warning('输入范围0～99超出最大限度');
        return 99;
      } else {
        return keepTNum;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>
